<template>
  <div>
    <vx-card title="" :is-filter="true" class="mb-8" :init-collapsed="true" :collapse-action="true" @keyup.enter="loadAgentApiKeys(1, true)">
      <template slot="actions">
        <vs-button color="primary" type="filled" icon-pack="feather" icon="icon-plus" size="small" @click="createAgentApiKey">{{ $t('add_agent_api_key') }}</vs-button>
      </template>

      <div class="vx-row">
        <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
          <vs-input :placeholder="$t('title')" v-model="agentApiSearchParams.agent_name" class="w-full"/>
        </div>
        <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
          <v-select :options="activeStatusOptions" :reduce="label => label.value" :placeholder="$t('is_active')" v-model="agentApiSearchParams.status" class="mb-4 md:mb-0" />
        </div>
      </div>

      <template slot="footer">
        <vs-button color="success" type="filled" class="w-full" @click.prevent="loadAgentApiKeys(1, true)" v-text="$t('search')"></vs-button>
      </template>
    </vx-card>

    <vx-card id="agentApiKeyDataContainer" :title="$t('agent_api_key')" class="mb-8 vs-con-loading__container">

      <vs-table hover-flat v-if="agentApiKeys && agentApiKeys.length" :data="agentApiKeys">
        <template slot="thead">
          <vs-th v-text="$t('no')"></vs-th>
          <vs-th v-text="$t('agent_name')"></vs-th>
          <vs-th v-text="$t('token')"></vs-th>
          <vs-th class="text-center" v-text="$t('status')"></vs-th>
          <vs-th class="text-center" v-text="$t('action')"></vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :key="key" v-for="(tr, key) in data">
            <vs-td v-text="tr.count"></vs-td>
            <vs-td v-text="tr.agent_name"></vs-td>
            <vs-td>
              <badge-clipboard :text="tr.token"></badge-clipboard>
            </vs-td>
            <vs-td class="text-center">
              <badge-enabled :enabled="tr.is_active == 1"></badge-enabled>
            </vs-td>
            <vs-td class="text-center">
              <div class="flex justify-center">
                <vs-button color="primary" type="border" icon-pack="feather" icon="icon-edit" size="small" @click.prevent="editAgentApiKey(tr.id)"></vs-button>&nbsp;
                <vs-button color="danger" type="filled" icon-pack="feather" icon="icon-trash-2" size="small" @click.prevent="deleteAgentApiKey(tr.id)"></vs-button>
              </div>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <vs-alert v-else class="flex justify-center p-0 h-auto" color="danger" active="true">
        <div v-text="$t('no_record')"></div>
      </vs-alert>

      <template slot="footer">
        <paginate
          :total="agentApiKeyPages"
          :click-handler="loadAgentApiKeys"
          v-model="initialPage"
          goto
        >
        </paginate>
      </template>
    </vx-card>

    <modal :title="$t('add_agent_api_key')" :active.sync="modals.add" size="md">
      <div class="mb-3">
        <label class="vs-input--label" v-text="$t('agent')"></label>
        <v-select :options="agentOptions" :reduce="label => label.value" :placeholder="$t('agent')" v-model="agentApiKeyFormData.agent_id" class="md:mb-0" />
        <validation-error :model-error="agentApiKeyFormErrors.agent_id"></validation-error>
      </div>
      <div class="mb-3">
        <vs-input :label="$t('token')" :placeholder="$t('token')" v-model="agentApiKeyFormData.token" class="w-full"/>
        <validation-error :model-error="agentApiKeyFormErrors.token"></validation-error>
      </div>
      <vs-checkbox v-model="agentApiKeyFormData.is_active" class="mb-3"><span v-text="$t('is_active')"></span></vs-checkbox>

      <vs-divider></vs-divider>

      <div class="flex justify-end">
        <vs-button id="addAgentApiKeyButton" color="primary" type="filled" @click.prevent="submitAgentApiKey">{{ $t('save') }}</vs-button>
      </div>
    </modal>

    <modal :title="$t('edit_agent_api_key')" :active.sync="modals.edit" size="md">
      <div id="agentApiKeyEditFormDataContainer" class="vs-con-loading__container">
        <div class="mb-3">
          <label class="vs-input--label" v-text="$t('agent')"></label>
          <v-select :options="agentOptions" :reduce="label => label.value" :placeholder="$t('agent')" v-model="agentApiKeyFormData.agent_id" class="md:mb-0" />
          <validation-error :model-error="agentApiKeyFormErrors.company_id"></validation-error>
        </div>
        <div class="mb-3">
          <vs-input :label="$t('token')" :placeholder="$t('token')" v-model="agentApiKeyFormData.token" class="w-full"/>
          <validation-error :model-error="agentApiKeyFormErrors.token"></validation-error>
        </div>
        <vs-checkbox v-model="agentApiKeyFormData.is_active" class="mb-3"><span v-text="$t('is_active')"></span></vs-checkbox>

        <vs-divider></vs-divider>

        <div class="flex justify-end">
          <vs-button id="editAgentApiKeyButton" color="primary" type="filled" @click.prevent="updateAgentApiKey">{{ $t('save') }}</vs-button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import { activeStatusOptions } from '@/config/options'
import Paginate from '@/components/Paginate'
import Modal from '@/components/Modal'
import Pagination from '@/mixins/paginate'
import AgentApiKey from '@/models/AgentApiKey'

export default {
  name: 'User.AgentApiKey',
  mixins: [Pagination],
  components: {
    Paginate,
    Modal
  },
  data () {
    return {
      agentApiKeys: {},
      agentApiKeyPages: 0,
      agentApiKeyFormData: {
        agent_id: '',
        token: '',
        is_active: 1
      },
      agentApiKeyFormErrors: [],
      agentApiSearchParams: {
        agent_name: '',
        status: ''
      },
      agentOptions: [],
      activeStatusOptions,
      modals: {
        add: false,
        edit: false
      }
    }
  },
  mounted () {
    this.loadAgentApiKeys(this.initialPage)
  },
  watch: {
    'modals.add' (val) {
      if (!val) {
        this.resetApiKeyForm()
      }
    },
    'modals.edit' (val) {
      if (!val) {
        this.resetApiKeyForm()
      }
    }
  },
  methods: {
    async loadAgentApiKeys (page = 1, backToPageOne = false) {
      this.$vs.loading({container: '#agentApiKeyDataContainer'})
      const response = await AgentApiKey.findAll({ ...this.agentApiSearchParams, page })
      this.agentApiKeys = response.data.data
      this.agentApiKeyPages = response.data.meta.pagination.last_page
      this.agentOptions = response.data.meta.options.agents
      if (backToPageOne === true) {
        this.initialPage = 1
      } else {
        this.initialPage = page
      }
      this.$vs.loading.close('#agentApiKeyDataContainer > .con-vs-loading')
    },
    async createAgentApiKey () {
      const response = await AgentApiKey.getKey()
      this.agentApiKeyFormData.token = response.data

      this.modals.add = true
    },
    async submitAgentApiKey () {
      this.$vs.loading({background: 'primary', color: '#fff', container: '#addAgentApiKeyButton', scale: 0.45})

      try {
        const response = await AgentApiKey.store(this.agentApiKeyFormData)

        this.$swalHelper.success({
          title: this.$t('action_success'),
          text: this.$t(response.data),
          confirmButton: this.$t('confirm')
        })

        this.modals.add = false

        this.loadAgentApiKeys()
        this.resetAgentApiKeyForm()
      } catch (e) {
        const errors = this.$swalHelper.displayCatchError({
          title: 'Error!',
          errorObject: e,
          confirmButton: this.$t('confirm')
        })
        this.apiKeyFormErrors = errors.validationErrors
      }

      this.$vs.loading.close('#addAgentApiKeyButton > .con-vs-loading')
    },
    async editAgentApiKey (id) {
      this.$vs.loading({container: '#agentApiKeyEditFormDataContainer'})

      try {
        this.modals.edit = true
        const response = await AgentApiKey.view({ id })
        this.agentApiKeyFormData = response.data.agentApiKey
      } catch (e) {
        this.$swalHelper.displayCatchError({
          title: 'Error!',
          errorObject: e,
          confirmButton: this.$t('confirm')
        })
      }

      this.$vs.loading.close('#agentApiKeyEditFormDataContainer > .con-vs-loading')
    },
    async updateAgentApiKey () {
      this.$vs.loading({background: 'primary', color: '#fff', container: '#editAgentApiKeyButton', scale: 0.45})

      try {
        const response = await AgentApiKey.update(this.agentApiKeyFormData)

        this.$swalHelper.success({
          title: this.$t('action_success'),
          text: this.$t(response.data),
          confirmButton: this.$t('confirm')
        })

        this.modals.edit = false

        this.loadAgentApiKeys()
        this.resetAgentApiKeyForm()
      } catch (e) {
        const errors = this.$swalHelper.displayCatchError({
          title: 'Error!',
          errorObject: e,
          confirmButton: this.$t('confirm')
        })
        this.apiKeyFormErrors = errors.validationErrors
      }

      this.$vs.loading.close('#editAgentApiKeyButton > .con-vs-loading')
    },
    async deleteAgentApiKey (id) {
      const confirm = await this.$swalHelper.warning({
        title: this.$t('are_you_sure_you_want_to_delete'),
        confirmButton: this.$t('execution'),
        cancelButton: this.$t('cancel')
      })

      if (confirm.value) {
        try {
          const response = await AgentApiKey.destroy({ id })

          this.$swalHelper.success({
            title: this.$t('action_success'),
            text: this.$t(response.data),
            confirmButton: this.$t('confirm')
          })

          this.loadAgentApiKeys()
        } catch (e) {
          this.$swalHelper.displayCatchError({
            title: 'Error!',
            errorObject: e,
            confirmButton: this.$t('confirm')
          })
        }
      }
    },
    resetAgentApiKeyForm () {
      this.agentApiKeyFormData = {
        agent_id: '',
        token: '',
        is_active: 1
      }
      this.agentApiKeyFormErrors = []
    }
  }
}
</script>

<style lang="scss">
#addAgentApiKeyButton,
#editAgentApiKeyButton {
  .con-vs-loading {
    position: absolute !important;
  }
}
</style>
